
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gp/baf",
      function () {
        return require("private-next-pages/gp/baf/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gp/baf"])
      });
    }
  